export default __webpack_public_path__ + "static/electrique-d7618706e24d3255b8d018cd266133bc.jpg";